import Vue from "vue";
import Router from "vue-router";
import { auth } from "@/firebase";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "home" */ "./views/Home.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Login.vue")
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Maintenance.vue")
    },
    {
      path: "/reset",
      name: "reset",
      component: () =>
        import(/* webpackChunkName: "reset_password" */ "./views/ResetPassword.vue")
    },
    {
      path: "/auth",
      name: "auth",
      component: () =>
        import(/* webpackChunkName: "reset_password" */ "./views/ResetPasswordConfirm.vue")
    },
    {
      path: "/admin",
      name: "admin",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/Admin.vue")
    },
    {
      path: "/basket",
      name: "basket",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "basket" */ "./views/Basket.vue")
    },
    {
      path: "/send_order",
      name: "send_order",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "basket" */ "./views/SendOrder.vue")
    },
    {
      path: "/resend_order",
      name: "resend_order",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/ResendOrder.vue")
    },
    {
      path: "/stress_order",
      name: "stress_order",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/StressOrder.vue")
    },
    {
      path: "/customer",
      name: "customer",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/Customer.vue")
    },
    {
      path: "/customer/:customerId",
      name: "customer_detail",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/CustomerDetail.vue")
    },
    {
      path: "/business-lines",
      name: "business-lines",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "admin" */ "./views/BusinessLines.vue")
    },
    {
      path: "/password",
      name: "password",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "change_password" */ "./views/ChangePassword.vue")
    },
    {
      path: "/change-email",
      name: "change-email",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "change_email" */ "./views/ChangeEmail.vue")
    },
    {
      path: "/order_status",
      name: "order_status",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "order_status" */ "./views/OrderStatus.vue")
    },
    {
      path: "/order_status/:orderNo",
      name: "order_status_detail",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "order_status" */ "./views/OrderStatusDetail.vue")
    },
    {
      path: "/search",
      name: "search",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue")
    },
    {
      path: "/table_to_basket",
      name: "table_to_basket",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "table_to_basket" */ "./views/TableToBasket.vue")
    },
    {
      path: "/address",
      name: "address",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "address" */ "./views/Address.vue")
    },
    {
      path: "/switch_customer",
      name: "switch_customer",
      meta: { requiresAuth: true },
      component: () =>
        import(/* webpackChunkName: "address" */ "./views/SwitchCustomer.vue")
    },
    {
      path: "/terms",
      name: "terms",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Terms.vue")
    },
    {
      path: "*",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/NotFound.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = auth.currentUser;
  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
